module.exports = __webpack_public_path__ + "static/media/unquizz.22f6e359.png";